import AuthenticationService from "./AuthenticationService";

export default class HttpService {
  private static getEndpoint(): string {
    // Use environment variable or fallback to empty string
    return process.env.REACT_APP_FUNC_ENDPOINT || "";
  }

  public static async httpGet<T>(url: string): Promise<T> {
    const endpoint = this.getEndpoint();
    const accessToken = await AuthenticationService.getAuthToken();
    const requestHeaders = { "Accept": "application/json", "Content-Type": "application/json", "Authorization": `Bearer ${accessToken}` };
    const response = await fetch(`${endpoint}/${url}`, { method: "GET", headers: requestHeaders });
    if (!response.ok) throw new Error(" > HttpService > Error in GET request - status: " + response.status);
    const result = await response.json();
    return result;
  }

  public static async httpPost<T>(url: string, data?: any): Promise<T> {
    const endpoint = this.getEndpoint();
    const accessToken = await AuthenticationService.getAuthToken();
    const requestHeaders = { "Accept": "application/json", "Content-Type": "application/json", "Authorization": `Bearer ${accessToken}` };
    const requestBody = data ? JSON.stringify(data) : undefined;
    const response = await fetch(`${endpoint}/${url}`, { method: "POST", headers: requestHeaders, body: requestBody });
    if (!response.ok) throw new Error(" > HttpService > Error in POST request - status: " + response.status);
    const responseText = await response.text();
    return responseText.length ? JSON.parse(responseText) : undefined as any;
  }

  public static async httpPut<T>(url: string, data?: any): Promise<T> {
    const endpoint = this.getEndpoint();
    const accessToken = await AuthenticationService.getAuthToken();
    const requestHeaders = { "Accept": "application/json", "Content-Type": "application/json", "Authorization": `Bearer ${accessToken}` };
    const requestBody = data ? JSON.stringify(data) : undefined;
    const response = await fetch(`${endpoint}/${url}`, { method: "PUT", headers: requestHeaders, body: requestBody });
    if (!response.ok) throw new Error(" > HttpService > Error in PUT request - status: " + response.status);
    const responseText = await response.text();
    return responseText.length ? JSON.parse(responseText) : undefined as any;
  }

  public static async httpDelete<T>(url: string): Promise<T> {
    const endpoint = this.getEndpoint();
    const accessToken = await AuthenticationService.getAuthToken();
    const requestHeaders = { "Accept": "application/json", "Content-Type": "application/json", "Authorization": `Bearer ${accessToken}` };
    const response = await fetch(`${endpoint}/${url}`, { method: "DELETE", headers: requestHeaders });
    if (!response.ok) throw new Error(" > HttpService > Error in DELETE request - status: " + response.status);
    const responseText = await response.text();
    return responseText.length ? JSON.parse(responseText) : undefined as any;
  }
}
